import { render, staticRenderFns } from "./BoothsPage.vue?vue&type=template&id=5c67ff8b&scoped=true&"
import script from "./BoothsPage.vue?vue&type=script&lang=ts&"
export * from "./BoothsPage.vue?vue&type=script&lang=ts&"
import style0 from "./BoothsPage.vue?vue&type=style&index=0&id=5c67ff8b&lang=scss&scoped=true&"
import style1 from "./BoothsPage.vue?vue&type=style&index=1&lang=css&"
import style2 from "./BoothsPage.vue?vue&type=style&index=2&id=5c67ff8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c67ff8b",
  null
  
)

export default component.exports